import { useCallback } from 'react'
import { useEditorStore } from '@/store/editorStore'
import { useStore } from 'zustand'
import { pageRepository } from '@/lib/container'

export function useEditor() {
  const store = useEditorStore()
  // zundo v2 exposes the temporal store directly on the store hook
  const { undo, redo, pastStates, futureStates } = useStore(useEditorStore.temporal)

  const canUndo = pastStates.length > 0
  const canRedo = futureStates.length > 0

  const save = useCallback(async () => {
    if (!store.pageId) return
    store.setIsSaving(true)
    try {
      await pageRepository.saveBlocks(store.pageId, store.blocks)
      store.setIsDirty(false)
    } finally {
      store.setIsSaving(false)
    }
  }, [store])

  return { ...store, undo, redo, canUndo, canRedo, save }
}
